import _each from "lodash/each";
import store from "~/js/store/store";
import { gsap, Quint, Circ, Cubic } from "gsap";
import Common from "~/js/common/common";
export default class Accordion {
  constructor() {
    this.setup();
    if (location.hash) {
      this.checkHashAndOpen(location.hash);
    }
  }
  setup() {
    const trimming = document.querySelectorAll(".js-trimming");
    _each(trimming, (elm, index) => {
      let _textContent = elm.textContent.substr(0, parseInt(elm.dataset.trimming))+"…";
      let _innerHTML = elm.innerHTML;
      elm.innerHTML = '<span class="_full">'+_innerHTML+'</span><span class="_trimming">'+_textContent+'</span>';
    });

    const path = location.pathname;
    const accordions = document.querySelectorAll(".js-accordion");
    const filteredSomeClassSelector = Array.from(accordions).filter((s) => {
      const target_page = s.getAttribute('href');
      if(!target_page || target_page == "#")return true;
      return target_page.indexOf(path) != -1
    });
    _each(filteredSomeClassSelector, (elm, index) => {
      elm.addEventListener("click", (event) => {
        let target = elm.getAttribute("data-target");
        let option = elm.getAttribute("data-option");
        if (target) {
          if (option && option === "noprevent") {
            // ヘッダーが表示されてしまう問題を解決するためのdispatch
            gsap.delayedCall(0.2, () => {
              store.dispatch("scrollY", {
                y: store.state.app.scrollY + 1
              });
            });
          } else {
            event.preventDefault();
          }
          this.toggleAccordion(target, elm, option);
        }
      });
    });

    const accordionTriggers = document.querySelectorAll('.js-accordion-trigger')
    _each(accordionTriggers, (elm) => {
      elm.addEventListener('click', (event) => {
        let target = event.currentTarget
        if (target) {
          this.checkHashAndOpen(target.getAttribute("href"))
        }
      })
    })
  }

    // ハッシュ指定時に該当タグ内にアコーディオンがあった場合に開く
  checkHashAndOpen(hash) {
    let target;
    try {
      target = document.querySelector(hash);
    } catch (e) {
      return;
    }

    if (target) {
      let accordion;
      if (target.classList.contains("js-accordion") || target.classList.contains("js-accordion__inner")) {
        accordion = target;
      } else {
        accordion = target.querySelector(".js-accordion");
        if (!accordion) {
          return;
        }
      }

      let accordionTarget = accordion.getAttribute("data-target");
      if (accordionTarget) {
        this.toggleAccordion(accordionTarget, accordion, null);
        gsap.delayedCall(0.4, () => {
          gsap.to(window, {
            duration: 0.6,
            ease: Cubic.easeInOut,
            scrollTo: {
              y: target.offsetTop - 80
            }
          });
        });
      }
    }
  }

  toggleAccordion(target, button, option) {
    let targetDom = document.querySelector(target);
    if (targetDom) {
      let result = false;
      if (option && option === "noprevent") {
        result = true;
        targetDom.classList.add("accordion-open");
      } else {
        result = targetDom.classList.toggle("accordion-open");
      }

      if (result) {
        button.classList.add("opened");
        if (option) {
          this.execOption(option, targetDom);
        }
      } else {
        button.classList.remove("opened");
      }
    }
  }

  execOption(option, target) {
    if (option === "noscroll") {
      Common.addNoscrollAllChildren(target, true);
    }
  }
}
